import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c7b9ca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-thumbs-up fs-5" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-hand-paper fs-5" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mx-2" }

import { numberWithCommas, SAAS_TYPE } from '@/constants/common'
import { translate } from '@/languages/i18n'
import { COMMUNITY_STORE, POST_STORE } from '@/store/constants'
import { computed, ComputedRef, PropType, ref } from 'vue'
import { useStore } from 'vuex'
import { POST_CONTENT_TYPE } from '@/store/modules/post'
import { isSaasTypePool } from '@/utils'

import { Modal } from 'bootstrap'

type Type = 'like' | 'interest'


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String as PropType<Type>,
    default: 'like',
  },
  dataBsTarget: String,
  dataBsToggle: String,
  like: Boolean,
  interest: Boolean,
  is_deleted_in_30_days: Number,
  available: Boolean,
  handleLikeOrInterest: {
    type: Function as PropType<() => void>,
  },
  count: {
    type: Number,
    default: 0,
  },
  id: Number,
  my_post: Boolean,
  loadingLike: Boolean,
  user_type: {
    type: String,
    default: '',
  },
  postContentType: {
    type: Number,
    default: POST_CONTENT_TYPE.ARTICLE,
  },
},
  setup(__props) {

const props = __props



const store = useStore()

const activeBtn: ComputedRef<boolean> = computed(() => props[props.type])
const interestOptions = computed<{ interest_display_setting_joboffer: boolean; interest_display_setting_recruitment: boolean }>(
  () => store.getters[COMMUNITY_STORE.GETTERS.GET_INTEREST_LIST_VISIBLE_OPTION]
)

const saasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])
const showModal = computed(() => store.getters[POST_STORE.GETTERS.POSTS]?.showModal)

const textObj = {
  like: translate('like'),
  interest: translate('interest'),
}

const modal = ref()

const handleClick = async () => {
  store.commit(POST_STORE.MUTATIONS.SHOW_MODAL, true)
  modal.value = new Modal(document.getElementById(props.type))
  if (props.type === 'like') {
    await store.dispatch(POST_STORE.ACTIONS.GET_LIKES, {
      id: props.id,
      params: '',
    })
  } else {
    await store.dispatch(POST_STORE.ACTIONS.GET_INTEREST, {
      id: props.id,
      params: '',
    })
  }
  if (showModal.value) {
    await modal.value?.show()
  }
}

const isEnableNumberClick = computed(() => {
  const { type, count, postContentType, my_post } = props
  const { interest_display_setting_joboffer, interest_display_setting_recruitment } = interestOptions.value

  // 興味ありのユーザ件数が0件の場合：リンクは非活性
  if (count === 0) {
    return false
  }

  if (isSaasTypePool(saasType.value) && !my_post) {
    return false
  }

  if (type === 'interest') {
    // 興味ありのユーザ件数が1件以上で投稿者以外の場合 && チェックがON --> リンクは活性で設定する
    if (postContentType === POST_CONTENT_TYPE.RECRUITMENT) {
      if (!my_post) {
        return interest_display_setting_recruitment
      }
    }

    // 興味ありのユーザ件数が1件以上で投稿者以外の場合 && チェックがON --> リンクは活性で設定する
    else if (postContentType === POST_CONTENT_TYPE.JOB_OFFER) {
      if (!my_post) {
        return interest_display_setting_joboffer
      }
    }
  }

  return true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleLikeOrInterest && __props.handleLikeOrInterest(...args))),
      class: _normalizeClass([
        _unref(activeBtn) ? 'active' : '',
        'border-0 me-2 rounded-pill fw-bold d-flex align-items-center disabled ',
        __props.interest ||
        (__props.is_deleted_in_30_days && __props.is_deleted_in_30_days === 0 && !__props.available && __props.user_type !== 'community_admin') ||
        (!__props.available && __props.user_type !== 'community_admin') ||
        (__props.is_deleted_in_30_days && __props.is_deleted_in_30_days !== 0 && __props.user_type !== 'community_admin') ||
        (__props.type === 'interest' && __props.my_post)
          ? 'prevent_click'
          : '',
        __props.loadingLike ? 'btn_opacity' : '',
      ]),
      disabled: __props.loadingLike
    }, [
      (__props.type === 'like')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
      _createElementVNode("span", _hoisted_9, _toDisplayString(textObj[__props.type]), 1)
    ], 10, _hoisted_2),
    _createElementVNode("span", {
      class: _normalizeClass([
        ' fs-8 ms-lg-0 ms-3 d-flex cursor-pointer bg-white fw-bold items-align-center justify-content-center fw-bold count-number',
        __props.interest || __props.like ? 'number' : '',
        !_unref(isEnableNumberClick) ? 'prevent_click' : 'text-decoration-underline',
      ]),
      onClick: handleClick
    }, _toDisplayString(_unref(numberWithCommas)(__props.count)), 3)
  ]))
}
}

})